import { apiGet, apiPatch, apiPost, refreshSession } from 'core/api/client';
import { endpoints } from 'core/api/endpoints';
import { applyTokenPayload, clearTokens, getRefreshToken } from 'auth/tokenStore';
import { adaptAuthSession, adaptUser, sanitizeProfilePatch } from 'auth/userAdapter';
import { adaptProfileOptions } from 'auth/profileOptions';

export const authApi = {
  requestOtp(body, config) {
    return apiPost(endpoints.otpRequest, body, { skipAuth: true, ...config });
  },
  verifyOtp(body, config) {
    return apiPost(endpoints.otpVerify, body, { skipAuth: true, ...config }).then(adaptAuthSession);
  },
  profileOptions(config) {
    return apiGet(endpoints.profileOptions, { skipAuth: true, ...config }).then(adaptProfileOptions);
  },
  me(config) {
    return apiGet(endpoints.me, config).then(adaptUser);
  },
  updateProfile(body, config) {
    return apiPatch(endpoints.profile, sanitizeProfilePatch(body), config).then(adaptUser);
  },
  refresh(refreshToken, config) {
    return refreshSession({
      refreshToken,
      signal: config?.signal,
    }).then(adaptAuthSession);
  },
  async logout(config) {
    const refreshToken = getRefreshToken();
    try {
      await apiPost(endpoints.logout, refreshToken ? { refresh_token: refreshToken } : {}, config);
    } finally {
      try {
        clearTokens();
      } catch {
        // Local teardown is best-effort after logout begins.
      }
    }
  },
  requestDeletion(config) {
    return apiPost(endpoints.deletionRequest, {}, config);
  },
  confirmDeletion(body, config) {
    return apiPost(endpoints.deletionConfirm, body, config);
  },
};

export function persistAuthPayload(data) {
  return applyTokenPayload(data);
}
